import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 15.167H6C2.38 15.167.833 13.62.833 10V6C.833 2.38 2.38.833 6 .833h4c3.62 0 5.167 1.547 5.167 5.167v4c0 3.62-1.547 5.167-5.167 5.167M6 1.833C2.927 1.833 1.833 2.927 1.833 6v4c0 3.073 1.094 4.167 4.167 4.167h4c3.073 0 4.167-1.094 4.167-4.167V6c0-3.073-1.094-4.167-4.167-4.167z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.32 5.24H1.68a.5.5 0 1 1 0-1h12.64a.5.5 0 1 1 0 1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.68 5.147a.504.504 0 0 1-.5-.5v-3.24c0-.274.227-.5.5-.5s.5.226.5.5v3.24c0 .273-.227.5-.5.5M10.32 4.847a.504.504 0 0 1-.5-.5v-2.94c0-.274.227-.5.5-.5s.5.226.5.5v2.94c0 .28-.22.5-.5.5M7.393 12.08q-.361-.002-.673-.173c-.453-.267-.72-.8-.72-1.474v-1.6c0-.673.267-1.213.727-1.48s1.06-.226 1.64.114l1.386.8c.58.333.92.833.92 1.366s-.34 1.034-.926 1.367l-1.387.8c-.32.187-.653.28-.967.28m.007-3.9a.35.35 0 0 0-.173.04c-.14.08-.227.307-.227.613v1.6c0 .3.087.527.227.614.14.08.38.04.64-.114l1.386-.8c.26-.153.42-.34.42-.5s-.153-.346-.42-.5l-1.386-.8c-.174-.1-.34-.153-.467-.153"
    }, null, -1)
  ]))]))
}
export default { render: render }